import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import { customStyles } from "../../../Bookclosure/Components/AddTaskModal";
import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as DocIcon } from "../../assets/icons/doc.svg";
import { ReactComponent as LeftIcon } from "../../assets/icons/left_arrow.svg";
import InputGroup from "./../../elements/InputGroup";
import bookclosure_taskstatus from "../../data/bookclosure_taskstatus.json";
import modules from "../../data/modules.json";
import FilterRow from "./FilterRow";
import CustomDropdownIndicator from "../../elements/CustomDropdownIndicator";

const BookClosureFilterModal = ({
  setBookClosureFilterModal,
  handleClose,
  companyId,
  assignOptions,
  approveOptions,
  getBookClosureData,
  filterAttr,
  checklistModules,
  setAppliedFilters
  // visible
}) => {
  const [module, setModule] = useState(null);
  const [assigneeId, setAssigneeId] = useState(null);
  const [approverId, setApproverId] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [status, setStatus] = useState(null);
  const [customFilter, setCustomFilter] = useState(false);
  const animatedComponents = makeAnimated();
  const [filterRows, setFilterRows] = useState([{}]);

  const addFilter = () => {
    setFilterRows((prev) => [...prev, {}]);
  };

  const updateFilterRow = (index, updated) => {
    setFilterRows((prev) => {
      return prev.map((row, i) => {
        if (i === index) {
          // Only update the row if `updated` is a valid object or a function.
          // If it's a function, call it with the current row
          return typeof updated === "function"
            ? updated(row)
            : { ...row, ...updated };
        }
        return row;
      });
    });
  };

  const applyFilter = (filterType) => {
    let filtersToApply = [];
    if (filterType === "basicFilter") {
      filtersToApply = [
        {
          ...(module && { modules: [module.value] }),
          ...(assigneeId && { assignees: [assigneeId.value] }),
          ...(approverId && { approvers: [approverId.value] }),
          ...(status && { statuses: [status.value] }),
          ...(dueDate && { dueDates: [dayjs(dueDate).format("DD-MM-YYYY")] }),
        },
      ];
    }
    if (filterType === "customFilter") {
      const filteredRows = filterRows.filter((row) => row.key && row.value);
      filtersToApply = [{ customFilters: filteredRows }];
    }

    getBookClosureData(companyId, filtersToApply);

    if (setAppliedFilters) {
      setAppliedFilters(filtersToApply);
    }

  };
  const removeFilterRow = (indexToRemove) => {
    setFilterRows((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const clearAllFilters = () => {
    setFilterRows([]);
    setTimeout(() => addFilter(), 0);
    // setBookClosureFilterModal(false);
  };

  const clearBasicFilters = () => {
    setModule(null);
    setAssigneeId(null);
    setApproverId(null);
    setDueDate(null);
    setStatus(null);
  };

  return (
    <Modal
      // visible={visible}
      width={`${customFilter ? "45%" : "35%"}`}
      minHeight={"350px"}
      title={
        customFilter ? (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
              onClick={() => setCustomFilter(false)}>
            <LeftIcon height={15} />
            <span style={{ marginTop:"1px" }}>Advanced Filters</span>
          </div>
        ) : (
          "Filters"
        )
      }
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          {!customFilter && (
            <div style={{  display:"flex",alignItems:"center",gap:"10px" }}>
              <label
                style={{ display:"flex",alignItems:"center",gap:"5px" }}
                className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
                onClick={() => setCustomFilter(true)}
              >
                <DocIcon height={15} /> Advanced Filter
              </label>
              <label
                style={{ color:"#4D6D64" }}
                className={`${commoncss.fs15} ${commoncss.clickable}`}
                onClick={() => {
                  clearBasicFilters();
                }}
              >
                Reset All
              </label>
            </div>
          )}
          {customFilter && filterRows.length > 0 && (
            <label
              className={`${commoncss.textLabel} ${commoncss.fs15} ${commoncss.clickable}`}
              onClick={clearAllFilters}
            >
              Reset All
            </label>
          )}
        </>
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setBookClosureFilterModal(false);
              handleClose();
            }}
            label="Cancel"
          />
          <span>
            {customFilter && (
              <Button
                btnColor={buttoncss.secondary}
                label="Add Filter"
                onClick={addFilter}
              />
            )}
            &ensp;
            <Button
              btnColor={buttoncss.primary}
              label="Apply Filter"
              onClick={() => {
                applyFilter(customFilter ? "customFilter" : "basicFilter");
              }}
            />
          </span>
        </>
      }
    >
      <div className={commoncss.pd1530}>
        {!customFilter && (
          <>
            <span className="input-label">Module</span>
            <Select
              placeholder="Select Module"
              name="module"
              value={module}
              onChange={setModule}
              options={checklistModules}
              className="w-100 mt-0"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

            <span className="input-label mt-2">Assignee</span>
            <Select
              placeholder="Select Assignee"
              name="assignee"
              value={assigneeId}
              onChange={setAssigneeId}
              options={assignOptions}
              className="w-100 mt-0"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

            <span className="input-label mt-2">Approver</span>
            <Select
              placeholder="Select Approver"
              name="approver"
              value={approverId}
              onChange={setApproverId}
              options={approveOptions}
              className="w-100 mt-0 mb-2"
              classNamePrefix="select"
              components={{
                ...animatedComponents,
                IndicatorSeparator: () => null,
                DropdownIndicator: CustomDropdownIndicator,
              }}
              styles={customStyles}
            />

            <InputGroup
              inputs={[
                <>
                  <InputGroup
                    label="Due Date"
                    inputs={[
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["DatePicker", "MobileDatePicker"]}
                          >
                            <MobileDatePicker
                              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                              value={dueDate ? dayjs(dueDate) : null}
                              onChange={(value) => {
                                setDueDate(value);
                              }}
                              format="DD-MMM-YYYY"
                              slotProps={{
                                textField: {
                                  InputProps: {
                                    disableUnderline: true,
                                  },
                                  inputProps: {
                                    placeholder: "DD-MM-YYYY",
                                  },
                                  sx: {
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                          />
                        </span>
                      </>,
                    ]}
                  />
                </>,
                <>
                  <span className="input-label">&nbsp;Status</span>
                  <Select
                    placeholder="Select Status"
                    name="status"
                    value={status}
                    onChange={setStatus}
                    options={bookclosure_taskstatus}
                    className="w-100 mt-0"
                    classNamePrefix="select"
                    components={{
                      ...animatedComponents,
                      IndicatorSeparator: () => null,
                      DropdownIndicator: CustomDropdownIndicator,
                    }}
                    styles={{
                      ...customStyles,
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                    menuPortalTarget={document.body} 
                  />
                </>,
              ]}
            />
          </>
        )}

        {customFilter && (
          <>
            {filterRows.map((_, index) => (
              <>
                <span className="input-label mt-1">&nbsp;Where</span>
                <div style={{ display: "flex", gap: "10px" }}>
                  <FilterRow
                    key={index}
                    onChange={(data) => updateFilterRow(index, data)}
                    filterAttr={filterAttr}
                    onRemove={() => removeFilterRow(index)}
                    assignOptions = {assignOptions}
                    approveOptions = {approveOptions}
                  />
                </div>
              </>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
};

export default BookClosureFilterModal;
